import { type StateCreator } from 'zustand';

export enum AssetModalViewMode {
  View = 'view',
  Comment = 'comment',
  EditImage = 'edit-image',
  EditVideo = 'edit-video',
}

export type AssetModalViewModeSlice = {
  viewMode: AssetModalViewMode;
  setViewMode: (viewMode: AssetModalViewMode) => void;
  resetViewMode: () => void;
};

export type CreateAssetModalViewModeSliceInitialState = Pick<Partial<AssetModalViewModeSlice>, 'viewMode'>;

const INITIAL_CREATE_ASSET_MODAL_VIEW_MODE_STATE = {
  viewMode: AssetModalViewMode.View,
} satisfies CreateAssetModalViewModeSliceInitialState;

export type CreateAssetModalViewModeSlice = (
  initialState: CreateAssetModalViewModeSliceInitialState,
) => StateCreator<AssetModalViewModeSlice, [], [], AssetModalViewModeSlice>;

export const createAssetModalViewModeSlice: CreateAssetModalViewModeSlice = (initialState) => (set) => {
  const mergedInitialState = {
    ...INITIAL_CREATE_ASSET_MODAL_VIEW_MODE_STATE,
    ...initialState,
  };

  return {
    ...mergedInitialState,
    setViewMode: (viewMode: AssetModalViewMode) =>
      set(
        {
          viewMode,
        },
        false,
      ),
    resetViewMode: () =>
      set(
        {
          viewMode: mergedInitialState.viewMode,
        },
        false,
      ),
  };
};
